import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import packageJson from "../../package.json";
import { DEFAULT_LANGUAGE, PRIORITY_LANGUAGES } from "./languages";

// use require for the cache because it doesn't have types
const Cache = require("i18next-localstorage-cache");

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(Cache)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANGUAGE, // default language
    fallbackLng: DEFAULT_LANGUAGE, // fallback language
    debug: false,
    supportedLngs: PRIORITY_LANGUAGES,
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    ns: ["common", "operating-manual", "data-hub-guide"], // All namespaces to load
    defaultNS: "common", // Default namespace
    backend: {
      // locale file path to use
      // update the translation cache when the version number has changed
      loadPath: `/locales/{{lng}}/{{ns}}.json?version=${packageJson.version}`,
    },
    cache: {
      // update the translation cache every 6 hours, even if the version number hasn't changed
      enabled: true,
      expirationTime: 6 * 60 * 60 * 1000, // 6 hours in milliseconds
    },
  })
  .then(() => {
    // Preload the priority language translation files
    i18n.loadLanguages(PRIORITY_LANGUAGES);
  });

export default i18n;
